import { DATE_TIME_FORMAT } from 'constants/Constants'
import config from 'config'
import { IndexProductDocument } from 'IndexProductScreen'
import { User } from 'hooks/useUsers'
import { EDITS_REQUESTED, ProductSearchResult } from 'models/SearchResult'
import moment from 'moment'
import React, { useState } from 'react'
import { toastError, toastSuccess } from 'services/Toast'
import { useAuth0Authentication } from 'hooks/useAuth0Authentication'


interface RequestEditsForm {
  comment?: string
}

export interface IInitialRequestEditsFormModal {
    formState: RequestEditsForm,
    isModalActive: boolean,
    isLoading: boolean,
    setIsModalActive: (val: boolean) => void,
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
    onCancel: (e: React.MouseEvent) => void,
    onConfirm: (e: React.MouseEvent, productSearchResult: ProductSearchResult, loggedInUser: User) => void,
    resetForm: () => void
}

const initialRequestEditsForm: RequestEditsForm = { comment: '' }

export const useRequestEditsFormModal = (markProductAsUpdated?: (val: boolean) => void): IInitialRequestEditsFormModal => {

    const [formState, setFormState] = useState<RequestEditsForm>(initialRequestEditsForm)
    const [isModalActive, setIsModalActive] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { getAuth0AccessToken } = useAuth0Authentication()

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => setFormState({comment: e.target.value})

    const onCancel = (e: React.MouseEvent) => {
        e.preventDefault()
        setFormState(initialRequestEditsForm)
        setIsModalActive(false)
    }

    const resetForm = () => {
        setFormState(initialRequestEditsForm)
    }

    const onConfirm = async (e: React.MouseEvent, productSearchResult: ProductSearchResult, loggedInUser: User) => {
      e.preventDefault()

        setIsLoading(true)

        const indexDoc: IndexProductDocument = {
          ...productSearchResult,
          metadata: {
            ...productSearchResult?.metadata,
            status: EDITS_REQUESTED,
            lastModerated: {
              byUserId: loggedInUser.user_id,
              byFullName: loggedInUser.name,
              timestamp: moment.utc().format(DATE_TIME_FORMAT),
              ...(formState.comment && { comment: formState.comment })
            }
          }
        }

        const accessToken: string = await getAuth0AccessToken()

        const response = await fetch(
            `${config.apiUrl}/products/edit`
                , {
                method: 'POST',
                redirect: 'follow',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": 'application/json'
                },
                body: JSON.stringify(indexDoc)
            }); 

        if (response.status === 201) {
            toastSuccess(`Success`)
            setIsLoading(false)
            markProductAsUpdated && markProductAsUpdated(true)
            setIsModalActive(false)
            resetForm()
              
        } else {
            toastError()
            setIsLoading(false)
        }
    }

  
  return {
    formState,
    isModalActive,
    isLoading,
    setIsModalActive,
    onChange,
    onCancel,
    onConfirm,
    resetForm

  }
}
